import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// actions importing
import { ONCHANGE_USERNAME, ONCHANGE_NAME_VIA_USERNAME, ONCHANAGE_TYPE_OF_USER } from "../../redux/reducer/_index";

// 3rd party impotying
import parse from 'html-react-parser';

// mui icon importing
import GroupTwoToneIcon from '@mui/icons-material/GroupTwoTone';

const FormContent = () => {

  // TODO: urlLink
  const urlLink = window.location.pathname;

  // TODO: navigate
  const navigate = useNavigate();

  // TODO: redux
  const data = useSelector((state: any) => state.appReducer.data);
  const dispatch = useDispatch();

  // TODO: onClick submit
  const _onClickSubmit = () => {
    sessionStorage.clear();

    dispatch(ONCHANGE_NAME_VIA_USERNAME());
    dispatch(ONCHANAGE_TYPE_OF_USER());

    // sessionStorage.removeItem("result");

    if (urlLink === "/student") {
      navigate("/student/question", { replace: true });
    } else {
      navigate("/parrent/question", { replace: true });
    }
  }

  return (
    <div className="flex flex-col w-full h-full bg-white p-5 text-black">
      {/* Hello */}
      <p className="text-center font-semibold text-red-500">CHÀO MỪNG BẠN ĐẾN VỚI BÀI TRẮC NGHIỆM DIAG HUB</p> <br />

      {parse(`${urlLink === "/student" ? data.student.welcomeTitle : data.parrent.welcomeTitle}`)} <br />

      <p>Bước 1: Nhập họ và tên ở phần bên dưới</p>
      <p>Bước 2: Nhấn nút "LÀM NGAY"</p>

      <br />

      {/* named */}
      <div className="flex flex-col w-full h-max justify-center items-center space-y-1">
        {/* title */}
        <div className="flex space-x-1 w-max h-max text-primary">
          <GroupTwoToneIcon />
          <p className="font-medium">Họ và tên</p>
        </div>

        {/* input */}
        <input
          className="
            bg-gray-100 h-[2rem] pl-1 pr-1 shadow-sm rounded-sm
            text-center
          "
          placeholder="--- Nhập họ và tên ---"
          onChange={(e: any) => {
            e.preventDefault();
            dispatch(ONCHANGE_USERNAME(e.target.value))
          }}
        />
      </div>

      <br />

      {/* submit button */}
      <div className="flex w-full justify-center items-center h-max">
        <button
          className={

            `text-green-600 ${data.username === "" ? "bg-gray-200" : "bg-sky-500 text-white font-medium hover:bg-red-500"}
            pl-3 pr-3 pt-2 pb-2 rounded-md
            `
          }
          disabled={data.username === "" ? true : false}
          onClick={_onClickSubmit}
        >
          LÀM NGAY
        </button>
      </div>
    </div>
  )
}

export default FormContent;
